<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters align-items-center justify-content-center">

        </div>
    </div>
</section>

<app-gallary-of-image></app-gallary-of-image>